import {ScreeningResultDTO} from './research-paper';
import {BaseDTO} from '../../../utils/base/dto';

export enum ScreeningType {
  SCREENING_ONE = 'SCREENING_ONE',
  SCREENING_TWO = 'SCREENING_TWO'
}

export enum ScreeningRunExcludeFilter {
  NO_ABSTRACT = 'NO_ABSTRACT',
  NO_PDF = 'NO_PDF',
}

export interface ScreeningRunDTO extends BaseDTO {
  screeningType: ScreeningType;
  passed: boolean;
  audited: boolean;
  result: ScreeningResultDTO[];
  processId: number;
  paperId: number;
}

export interface ScreeningProcessDTO extends BaseDTO {
  criteria: string;
  manuelOverrideScreeningOne?: boolean | null;
  manuelOverrideScreeningTwo?: boolean | null;
  screeningOverrideReason?: string;
  screeningOne?: ScreeningRunDTO;
  screeningTwo?: ScreeningRunDTO;
  projectId: number;

  languageModel?: string;
  embeddingModel?: string;
}
